import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ServiceUsageCardCmp_ResolvableServiceBaseInterface_Fragment =
  graphql(`
    fragment ServiceUsageCardCmp_ResolvableServiceBaseInterface_Fragment on ResolvableServiceBaseInterface {
      _id
      __typename
      title
      value {
        discountAmount {
          ...ResolvableAmountCmp_ResolvableAmount_Fragment
        }
        discountPercentage {
          ...ResolvablePercentCmp_ResolvablePercent_Fragment
        }
        priceExcludingVat {
          ...ResolvableAmountCmp_ResolvableAmount_Fragment
        }
        vatId {
          ...ResolvableIdCmp_ResolvableId_Fragment
        }
      }
      code
      codingConfig {
        ...CodeCmp_CodingConfig_Fragment
      }
      content
      costUsages {
        costId
        index
        quantity {
          value
          unitId
        }
      }
      label
      materialUsages {
        materialId
        index
        quantity {
          value
          unitId
        }
      }
    }
  `);

export type ServiceUsageCardCmp_ResolvableServiceBaseInterface = ResultOf<
  typeof ServiceUsageCardCmp_ResolvableServiceBaseInterface_Fragment
>;
